
import symbolsData from '../../../shared/constants/symbols.json';

export const BACKTEST = {
    "SYMBOL": symbolsData.SYMBOLS,
    "PERIOD": [
        { "value": "M1", "description": "1 minute" },
        { "value": "M2", "description": "2 minutes" },
        { "value": "M3", "description": "3 minutes" },
        { "value": "M4", "description": "4 minutes" },
        { "value": "M5", "description": "5 minutes" },
        { "value": "M6", "description": "6 minutes" },
        { "value": "M10", "description": "10 minutes" },
        { "value": "M12", "description": "12 minutes" },
        { "value": "M15", "description": "15 minutes" },
        { "value": "M20", "description": "20 minutes" },
        { "value": "M30", "description": "30 minutes" },
        { "value": "H1", "description": "1 hour" },
        { "value": "H2", "description": "2 hours" },
        { "value": "H3", "description": "3 hours" },
        { "value": "H4", "description": "4 hours" },
        { "value": "H6", "description": "6 hours" },
        { "value": "H8", "description": "8 hours" },
        { "value": "H12", "description": "12 hours" },
        { "value": "D1", "description": "1 day" },
        { "value": "W1", "description": "1 week" },
        { "value": "MN1", "description": "1 month" }
    ],
    "EXECUTE_MODE": [
        { "value": "0", "description": "Zero latency, ideal execution" },
        { "value": "1", "description": "1 ms" },
        { "value": "5", "description": "5 ms" },
        { "value": "10", "description": "10 ms" },
        { "value": "20", "description": "20 ms" },
        { "value": "50", "description": "50 ms" },
        { "value": "100", "description": "100 ms" },
        { "value": "500", "description": "500 ms" },
        { "value": "1000", "description": "1000 ms" },
        { "value": "-1", "description": "Random delay" },
        { "value": "-2", "description": "Custom delay" },
    ],
    "MODEL": [
        { "value": "0", "description": "Every tick" },
        { "value": "1", "description": "Every tick based on real ticks" },
        { "value": "2", "description": "1 minute OHLC" },
        { "value": "3", "description": "Open prices only" },
        { "value": "4", "description": "Math calculations" },
    ],
    "DEPOSIT_CURRENCY": [
        { "value": "USD", "description": "USD" },
        { "value": "EUR", "description": "EUR" },
        { "value": "GBP", "description": "GBP" },
        { "value": "CHF", "description": "CHF" },
        { "value": "RUB", "description": "RUB" },
    ]
}
